import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { DirectionsService } from '../utilities/DirectionsService/DirectionsService';
import { MainService } from '../services/optimizer-service/optimizer.service';
import { MapControls } from '../utilities/MapControls/MapConrols';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import { DateConstants } from '../utilities/WeekSchedule/DateConstants';
import { Trip } from '../DataStructures/Trip/Trip';
import { decode, encode } from "@googlemaps/polyline-codec";
import { UnitConverter } from '../utilities/unit-converter/UnitConverter';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormUtils } from '../utilities/FormUtils/FormUtils';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { m } from '@angular/core/src/render3';
declare var google: any;
@Component({
  selector: 'app-book-ride',
  templateUrl: './book-ride.component.html',
  styleUrls: ['./book-ride.component.css']
})
export class BookRideComponent implements OnInit {

  submitted = false;
  requestForm: FormGroup;
  formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  @ViewChild('map') mapReference: ElementRef;

  zoom = 13;
  time = '0h 0m';
  distance = 0;
  price;
  params;
  navOptions = NavBarComponent.standard;
  constructor(private formBuilder: FormBuilder,public mapControls: MapControls, private route: ActivatedRoute, private dialog: MatDialog, private main: MainService) {
    this.params = this.route.snapshot.queryParams;


    this.requestForm = this.formBuilder.group({
      from: [null, [Validators.required]],
      to: [null, [Validators.required]],
      fromlat: [null, [Validators.required]],
      fromlng: [null, [Validators.required]],
      tolat: [null, Validators.required],
      tolng: [null, Validators.required],
      date: [null, [Validators.required]],
      time: [null, [Validators.required]],
      passengers:[null,[Validators.required]],
      firstname:[null,[Validators.required]],
      lastname:[null,[Validators.required],],
      email:[null,[Validators.email]],
      phone:[null,[Validators.required,Validators.minLength(10), Validators.pattern('^[0-9]+$')]],
      cost:[null,[Validators.required]],
      costText:[null,[Validators.required]]
    });

    this.requestForm.patchValue({
      from:this.params.from,
      fromlat:this.params.fromlat,
      fromlng:this.params.fromlng,
      to:this.params.to,
      tolat:this.params.tolat,
      tolng:this.params.tolng,
      date:this.params.date,
      time:this.params.time,
      passengers:this.params.passengers,
      firstname:this.params.firstname,
      lastname:this.params.lastname,
      email:this.params.email,
      phone:this.params.phone
    });
  }

  formatDate(date) {
    if (date) {
      return moment(date).format(DateConstants.shortDateTimeFormatNoTime);
    } else {
      return 'N/A';
    }
  }

  ngOnInit() {

    this.mapControls.initialize(this.mapReference);
    const mapStyles = [
      {
        featureType: "all",
        elementType: "geometry",
        stylers: [{ color: "#eaeaea" }]
      },
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [{ visibility: "on" }, { color: "#808080" }]
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ color: "#808080" }]
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#f1f1f1" }]
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }]
      }
    ];
    this.mapControls.createMapAndCenterOnLoaction(this.params.fromlat, this.params.fromlng, true, false, mapStyles);
    this.mapControls.map.setZoom(this.zoom);
    // Marker positions
    const position1 = { lat: parseFloat(this.params.fromlat), lng: parseFloat(this.params.fromlng) }; // Marker 1 (San Francisco)
    const position2 = { lat: parseFloat(this.params.tolat), lng: parseFloat(this.params.tolng) }; // Marker 2 (Oakland)

    // Add markers to the map
    const marker1 = new google.maps.Marker({
      position: position1,
      map: this.mapControls.map,
      title: "A",
      icon: {
        url: "../../assets/number_1.png", // URL to your custom icon
        scaledSize: new google.maps.Size(30, 45), // Scale the icon to 50x50 pixels
      }
    });

    const marker2 = new google.maps.Marker({
      position: position2,
      map: this.mapControls.map,
      title: "B",
      icon: {
        url: "../../assets/number_2.png", // URL to your custom icon
        scaledSize: new google.maps.Size(30, 45), // Scale the icon to 50x50 pixels
      }
    });

    this.drawDirections();

  }

  submit(){
    FormUtils.markFormGroupTouched(this.requestForm); 
    if(this.requestForm.valid){
      var d = new QuickDialog(this.dialog).LoadingDialog("Booking Your Ride...");
      this.main.submitBooking(this.requestForm.getRawValue()).then((res) =>{
        d.close();
        this.submitted = true;
      }).catch(e =>{
        new QuickDialog(this.dialog).InfoDialog("We were unable to submit your request at this time, please try again.","Sorry","OK");
      })
    }
  }

  formatPrice(){

  }

  drawDirections() {
    var source = {
      lat: this.params.fromlat,
      lng: this.params.fromlng
    }
    var dest = {
      lat: this.params.tolat,
      lng: this.params.tolng
    }

    this.main.rawDirections(source, dest).then((res) => {
      this.time = new UnitConverter().secondsToFormattedTime(res.totalDuration);
      this.distance = res.totalDistance;
      this.requestForm.patchValue({
        cost:150 * (this.distance/1000),
      })
      this.requestForm.patchValue({
        costText:this.formattedNumber.format(this.requestForm.getRawValue().cost)
      })
      var overviewPath = res.legs[0].routes[0].overview_polyline.points;
      var decoded = decode(overviewPath, 5)

      // Create a Polyline object to draw the route on the map
      var routePolyline = new google.maps.Polyline({
        path: decoded.map(x => { return { lat: x[0], lng: x[1] } }),
        strokeColor: '#3498db', // Color of the polyline
        strokeWeight: 5
      });

      routePolyline.setMap(this.mapControls.map);
      const bounds = new google.maps.LatLngBounds();

      // Extend bounds for each leg of the route
      res.legs[0].routes[0].legs.forEach(leg => {
        leg.steps.forEach(step => {
          bounds.extend(step.start_location);
          bounds.extend(step.end_location);
        });
      });

      // Adjust the map to fit the bounds
      this.mapControls.map.fitBounds(bounds);
    }).catch(e => {
      console.log(e);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/book-ride/book-ride.component.ts